
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class CyberpunkCityEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, height } = pc;
        const spacing = (400 + layerIndex * 200) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2 } = this.getGridBounds(pc, spacing);

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing) {
            const w = spacing * 0.8 * (config.parallaxScale || 1.0);
            const h = height * (0.2 + this.pseudoRandom(x) * 0.6) * (1 / layerIndex) * (config.parallaxComplexity || 1.0);
            
            const draw = () => {
                ctx.fillRect(x, height - h, w, h);
                // Windows
                ctx.fillStyle = 'rgba(255, 255, 0, 0.2)';
                const winSpacingX = 10 * (config.parallaxScale || 1.0);
                const winSpacingY = 15 * (config.parallaxScale || 1.0);
                const winSize = 5 * (config.parallaxScale || 1.0);

                for (let wx = x + winSpacingX; wx < x + w - winSpacingX; wx += winSpacingX) {
                    for (let wy = height - h + winSpacingY; wy < height - winSpacingY; wy += winSpacingY) {
                        if (this.pseudoRandom(wx + wy) > 0.7) {
                            ctx.fillRect(wx, wy, winSize, winSize * 1.5);
                        }
                    }
                }
                ctx.fillStyle = pc.color; // Reset
            };
            draw();
            this.applyGlow(pc, draw);
        }
    }
}
